<template lang="pug">
v-app.Poppins
  DialogArteDivulgacao(ref="dialogArte")
  dialog-historico-alteracoes(ref="dialogHistorico")

  //- ── Dialog de ativação de template de cupom (compartilhado com Lista.vue) ──
  dialog-ativar-cupom-template(
    ref="dialogTemplate",
    :estabelecimento="estabelecimentoSelecionado",
    :cupons="cupons",
    :bloqueio="bloqueioMarketing",
    :metricas28d="metricas28d",
    :bairros-estabelecimento="bairrosEstabelecimento",
    :is-cardapio-digital="cardapioDigital",
    :loading-bairros="loadingBairros",
    :loading-metricas="loadingMarketing",
    @saved="onCupomSalvo",
    @ativado="abrirArteCupom"
  )

  //- ── Dialog de confirmação de ativação de promoção ──────────────────────────
  v-dialog(v-model="dialogPromo.open", width="420", persistent)
    v-card.Poppins(style="border-radius:14px;")
      v-card-title.font-weight-semibold.Poppins(style="font-size:18px;") Ativar promoção
      v-card-text.Poppins(style="font-size:14px;color:#5B5B5B;") Ativar a promoção do item "{{ dialogPromo.promo ? dialogPromo.promo.nome : '' }}"? Ela ficará visível para os clientes no app.
      v-card-actions.Poppins
        v-spacer
        v-btn(flat, :disabled="dialogPromo.loading", @click="fecharDialogPromo") Fechar
        v-btn.white--text(
          color="#1d9a5a",
          depressed,
          :loading="dialogPromo.loading",
          @click="confirmarAtivacaoPromo"
        ) Ativar

  //- ── Dialog com o motivo do bloqueio (ao clicar num CTA bloqueado) ───────────
  v-dialog(v-model="dialogBloqueio", width="440")
    v-card.Poppins(style="border-radius:14px;", v-if="bloqueioMarketing.motivo")
      v-card-title.font-weight-semibold.Poppins(style="font-size:18px;") {{ bloqueioMarketing.motivo.titulo }}
      v-card-text.Poppins(style="font-size:14px;color:#5B5B5B;")
        p {{ bloqueioMarketing.motivo.mensagem }}
        p.mb-0
          b Como desbloquear:&nbsp;
          | {{ comoDesbloquear }}
      v-card-actions.Poppins
        v-btn.white--text(
          v-if="bloqueioMarketing.motivo.tipo === 'suspenso'",
          color="#B3261E",
          depressed,
          @click="abrirSuporte('marketing_dialog_bloqueio')"
        )
          v-icon(left, small) support_agent
          | Falar com o Suporte
        v-spacer
        v-btn(flat, @click="dialogBloqueio = false") Fechar

  v-container(grid-list-xl, fluid)
    v-layout(row, wrap)
      v-flex(lg12)
        .headline.font-weight-bold Marketing
        .body-1.grey--text.text--darken-1 Ferramentas para atrair, converter e fidelizar mais clientes

    //- ── Aviso quando nenhuma loja está selecionada ───────────────────────────
    .selecaoLojaAviso(v-if="!estabelecimentoSelecionado")
      .selecaoLojaAviso__icon
        v-icon(color="#B26A00", size="22") storefront
      .selecaoLojaAviso__content
        .selecaoLojaAviso__title.Poppins Selecione uma loja para gerenciar suas campanhas
        .selecaoLojaAviso__desc.Poppins Cupons e promoções são vinculados a uma loja específica. Escolha qual deseja configurar para liberar as ferramentas abaixo.
      v-btn.selecaoLojaAviso__cta.white--text(small, depressed, @click="abrirSelecaoLoja")
        v-icon(left, small) storefront
        | Selecionar loja

    template(v-if="estabelecimentoSelecionado")
      //- ── Estado bloqueado: banner no lugar do nível ──────────────────────────
      .bloqueioBanner.mt-3(v-if="bloqueado")
        .bloqueioBanner__icon ⚠️
        .bloqueioBanner__content
          .bloqueioBanner__kicker.Poppins MARKETING TEMPORARIAMENTE BLOQUEADO
          .bloqueioBanner__titulo.Poppins {{ bloqueioMarketing.motivo.titulo }}
          .bloqueioBanner__mensagem.Poppins {{ bloqueioMarketing.motivo.mensagem }}
          .bloqueioBanner__como.Poppins
            b Como desbloquear:&nbsp;
            | {{ comoDesbloquear }}
          v-btn.bloqueioBanner__cta.white--text.Poppins.mt-3(
            v-if="bloqueioMarketing.motivo && bloqueioMarketing.motivo.tipo === 'suspenso'",
            small, depressed, @click="abrirSuporte('marketing_banner_bloqueio')")
            v-icon(left, small) support_agent
            | Falar com o Suporte

      //- ── Card do nível de destaque (oculto no cardápio digital) ───────────────
      nivel-destaque-card.mt-3(v-else-if="!cardapioDigital", :nivel-info="nivelInfo", :loading="loadingMarketing")

      //- ── Skeleton das seções ─────────────────────────────────────────────────
      template(v-if="loadingMarketing")
        v-layout.mt-3(row, wrap)
          v-flex(xs12)
            .skeleton-line.skeleton-line--md
        v-layout(row, wrap)
          v-flex(xs12, sm6, md3, v-for="n in 4", :key="'skc-' + n")
            .previewSkeleton
              .skeleton-line.skeleton-line--xl
              .skeleton-line.mt-2
              .skeleton-line.skeleton-line--short.mt-2
              .previewSkeleton__cta.skeleton-line.mt-3

      //- ── Estado principal: seções sempre visíveis (prévias ou CTA) ───────────
      template(v-else)
        //- Arte de boas-vindas: disponível sem prazo e com o mesmo bloqueio das
        //- demais ações de marketing.
        .secaoCta.secaoCta--verde.boasVindas.mt-3
          img.boasVindas__thumb(:src="miniaturaBoasVindas", alt="")
          .secaoCta__textos
            .secaoCta__titulo.Poppins
              | Divulgue a chegada da sua loja
              span.secaoHeader__lock(v-if="bloqueado") 🔒
            .secaoCta__sub.Poppins {{ textoBoasVindas }}
          v-btn.secaoCta__btn.secaoCta__btn--verde.elevation-0.white--text.Poppins(depressed, @click="abrirArteBoasVindas")
            | Ver arte →

        //- Seção: Promoções disponíveis (uma card por promoção)
        template(v-if="!cardapioDigital")
          v-layout.mt-3(row, wrap, align-center, v-if="promosParaAtivar.length")
            v-flex
              .secaoHeader
                span.secaoHeader__titulo.Poppins(:class="{ 'secaoHeader__titulo--bloqueado': bloqueado }") Promoções disponíveis
                span.secaoHeader__badge.secaoHeader__badge--laranja.Poppins {{ promosParaAtivar.length }}
                span.secaoHeader__lock(v-if="bloqueado") 🔒
            v-flex(shrink)
              a.secaoHeader__link.secaoHeader__link--laranja.Poppins(@click="verPromocoes") Gerenciar promoções →
          .mktCarrossel.mt-3(v-if="promosParaAtivar.length")
            .mktCarrossel__item.mktCarrossel__item--promo(v-for="promo in promosParaAtivar", :key="promo.id")
              campanha-preview-card(
                :promo="promo",
                :bloqueado="bloqueado",
                :ultima-alteracao="ultimasAlteracoesPromo[promo.id]",
                @ativar="abrirAtivacaoPromo",
                @historico="abrirHistoricoPromo"
              )
          .secaoCta.secaoCta--laranja(v-else)
            .secaoCta__icon 🚀
            .secaoCta__textos
              .secaoCta__titulo.Poppins {{ promosAtivas.length ? (promosAtivas.length + (promosAtivas.length === 1 ? ' promoção ativa' : ' promoções ativas')) : 'Nenhuma promoção nova no momento' }}
              .secaoCta__sub.Poppins {{ promosAtivas.length ? 'Gerencie as promoções da sua loja e acompanhe as campanhas disponíveis.' : 'Assim que houver novas campanhas de promoção, elas aparecem aqui para você ativar.' }}
            v-btn.secaoCta__btn.secaoCta__btn--laranja.elevation-0.white--text.Poppins(depressed, @click="verPromocoes")
              | Ver minhas promoções →

        //- Seção: Cupons para ativar
        v-layout.mt-3(row, wrap, align-center, v-if="templatesPendentes.length")
          v-flex
            .secaoHeader
              span.secaoHeader__titulo.Poppins(:class="{ 'secaoHeader__titulo--bloqueado': bloqueado }") Cupons para ativar
              span.secaoHeader__badge.secaoHeader__badge--verde.Poppins {{ templatesPendentes.length }}
              span.secaoHeader__lock(v-if="bloqueado") 🔒
          v-flex(shrink)
            a.secaoHeader__link.secaoHeader__link--verde.Poppins(@click="gerenciarCupons") Gerenciar cupons →
        .mktCarrossel.mt-3(v-if="templatesPendentes.length")
          .mktCarrossel__item.mktCarrossel__item--cupom(v-for="(cupom, i) in templatesPendentes", :key="'tpl-' + i")
            cupom-template-card(:cupom="cupom", :bloqueado="bloqueado", @ativar="abrirAtivacaoCupom")
        .secaoCta.secaoCta--verde(v-else)
          .secaoCta__icon 🎟️
          .secaoCta__textos
            .secaoCta__titulo.Poppins {{ cuponsAtivos.length ? (cuponsAtivos.length + (cuponsAtivos.length === 1 ? ' cupom ativo' : ' cupons ativos')) : 'Nenhum cupom para ativar agora' }}
            .secaoCta__sub.Poppins {{ cuponsAtivos.length ? 'Você já ativou os cupons sugeridos. Gerencie ou crie novos cupons quando quiser.' : 'Crie cupons para atrair novos clientes e reativar quem já comprou.' }}
          v-btn.secaoCta__btn.secaoCta__btn--verde.elevation-0.white--text.Poppins(depressed, @click="gerenciarCupons")
            | Ver meus cupons →

        //- Rodapé: aviso (bloqueado) ou dica padrão
        .bloqueioNota.Poppins(v-if="bloqueado") 🔒 As ofertas continuam reservadas para a sua loja — ao resolver o bloqueio, tudo volta a ficar disponível automaticamente.
        .marketingTip(v-else)
          .marketingTip__head
            v-icon.marketingTip__icon(color="#3060CA", size="22") tips_and_updates
            .marketingTip__title.Poppins(v-if="cardapioDigital") Cupons fidelizam clientes e impulsionam seus pedidos
            .marketingTip__title.Poppins(v-else) Combine cupom + promoção para maximizar o resultado
          .marketingTip__desc.Poppins(v-if="cardapioDigital") Quem cria pelo menos um cupom ativo costuma atrair mais novos clientes e ver mais pedidos por mês. Aproveite os modelos prontos para começar.
          .marketingTip__desc.Poppins(v-else) Cupons trazem o cliente até você e promoções aumentam o ticket médio. Quem usa as duas estratégias juntas vê o maior crescimento em pedidos.
</template>

<script>
import _ from 'lodash';
import { calcularMetricasCancelamento, avaliarBloqueio } from '@/util/estabelecimentoBloqueio';
import { filtrarSectionsPendentes, isCupomAtivo } from '@/util/cupom';
import { isAtivoPromo, isNovidadePromo } from '@/util/promocao';
import { calcularNivelDestaque } from '@/util/nivelDestaque';
import DialogAtivarCupomTemplate from '@/components/dialog/DialogAtivarCupomTemplate';
import NivelDestaqueCard from '@/components/marketing/NivelDestaqueCard';
import CupomTemplateCard from '@/components/marketing/CupomTemplateCard';
import CampanhaPreviewCard from '@/components/marketing/CampanhaPreviewCard';
import DialogArteDivulgacao from '@/components/dialog/DialogArteDivulgacao';
import DialogHistoricoAlteracoes from '@/components/dialog/DialogHistoricoAlteracoes';
import ArteDivulgacao from '@/util/arteDivulgacao';
import { ORIGEM_ONBOARDING } from '@/util/onboarding';
import { ENTIDADE_ITEM, buscarUltimasAlteracoes } from '@/util/logAtivacao';
import { registrarContatoSuporte } from '@/util/suporte';

export default {
  name: 'Marketing',
  components: {
    DialogAtivarCupomTemplate,
    NivelDestaqueCard,
    CupomTemplateCard,
    CampanhaPreviewCard,
    DialogArteDivulgacao,
    DialogHistoricoAlteracoes,
  },
  data() {
    return {
      pedidosSmart: [],
      estabelecimentoBloqueio: null,
      loadingMarketing: true,
      loadingBairros: false,
      fetchToken: 0,
      cupons: [],
      sectionsRemotas: [],
      promos: [],
      ultimasAlteracoesPromo: {},
      bairrosEstabelecimento: [],
      dialogPromo: {
        open: false,
        promo: null,
        loading: false,
      },
      dialogBloqueio: false,
    };
  },
  computed: {
    estabelecimentoSelecionado() {
      return this.$root.estabelecimentoSelecionado;
    },
    cardapioDigital() {
      return !!(this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.cardapio_digital);
    },
    miniaturaBoasVindas() {
      return ArteDivulgacao.miniaturaBoasVindas(this.estabelecimentoSelecionado);
    },
    textoBoasVindas() {
      if (this.$root.isOnboardingAguardando) {
        return 'Arte pronta para feed, stories e WhatsApp. Publique depois que a loja for ativada.';
      }
      return 'Arte pronta para feed, stories e WhatsApp, com legenda.';
    },
    bloqueioMarketing() {
      const lojaAtual = this.estabelecimentoSelecionado;
      if (this.loadingMarketing || !this.estabelecimentoBloqueio || !lojaAtual || this.estabelecimentoBloqueio.id !== lojaAtual.id) {
        return { ativo: false, motivo: null };
      }
      const metricas = calcularMetricasCancelamento(this.pedidosSmart);
      const result = avaliarBloqueio({
        estabelecimento: this.estabelecimentoBloqueio,
        metricas: metricas,
        contexto: 'marketing',
      });
      const motivo = (result.motivo && result.motivo.tipo !== 'sem_estabelecimento')
        ? result.motivo
        : null;
      return { ativo: !!motivo, motivo };
    },
    bloqueado() {
      return this.bloqueioMarketing.ativo;
    },
    comoDesbloquear() {
      const motivo = this.bloqueioMarketing.motivo;
      if (motivo && motivo.tipo === 'suspenso') {
        return 'entre em contato com o Suporte do Bigou para regularizar o contrato da loja.';
      }
      const faltam = (motivo && motivo.pedidosParaRegularizar) || 0;
      const plural = faltam === 1 ? 'pedido' : 'pedidos';
      return 'aceite ' + faltam + ' ' + plural + ' sem cancelar nenhum para regularizar.';
    },
    // Métricas dos últimos 28 dias usadas pelos templates "inteligentes" do dialog.
    metricas28d() {
      const validos = this.pedidosSmart.filter(o => o.status === 1 || o.status === 2);
      if (validos.length < 5) return null;
      const totais = validos.map(o => o.subtotal || 0);
      const ticketMedio = _.mean(totais);
      const comTaxa = validos.filter(o => o.taxa_entrega > 0);
      const taxaMedia = comTaxa.length ? _.meanBy(comTaxa, 'taxa_entrega') : 0;
      return { ticketMedio, taxaMedia, qtdPedidos: validos.length };
    },
    cuponsAtivos() {
      return this.cupons.filter(isCupomAtivo);
    },
    sectionsPendentes() {
      return filtrarSectionsPendentes(this.sectionsRemotas, this.cupons);
    },
    templatesPendentes() {
      return _.flatten(this.sectionsPendentes.map(sec => sec.templates || []));
    },
    promosAtivas() {
      return this.promos.filter(isAtivoPromo);
    },
    // Todas as promoções disponíveis para ativar (não ativas), novidades primeiro
    // e agrupadas por nome de campanha como critério secundário.
    promosParaAtivar() {
      const naoAtivas = this.promos.filter(p => !isAtivoPromo(p));
      return _.orderBy(
        naoAtivas,
        [p => (isNovidadePromo(p) ? 0 : 1), p => String(p.campanha_nome || '').toLowerCase()],
        ['asc', 'asc']
      );
    },
    nivelInfo() {
      const ativas = this.cuponsAtivos.length + this.promosAtivas.length;
      const totais = ativas + this.templatesPendentes.length + this.promosParaAtivar.length;
      return calcularNivelDestaque({ acoesAtivas: ativas, acoesTotais: totais });
    },
  },
  watch: {
    '$root.estabelecimentoSelecionado.id': {
      immediate: true,
      sync: true,
      handler() {
        this.carregarMarketing();
      },
    },
    // O parceiro pode já estar no Marketing ao clicar no convite do onboarding:
    // nesse caso não há mount novo, só a query muda.
    '$route.query.origem'() {
      this.verificarOrigemOnboarding();
    },
  },
  mounted() {
    this.verificarOrigemOnboarding();
  },
  methods: {
    // Parceiro chegou pelo convite do onboarding: limpa o marcador da URL (para
    // um refresh não repetir o efeito) e leva a tela direto para as ações.
    verificarOrigemOnboarding() {
      if (this.$route.query.origem !== ORIGEM_ONBOARDING) {
        return;
      }
      this.$router.replace({ query: _.omit(this.$route.query, ['origem']) }).catch(() => {});
      this.focarAcoesAoCarregar();
    },
    // As seções só existem depois que o skeleton sai: espera o loading terminar.
    focarAcoesAoCarregar() {
      if (!this.loadingMarketing) {
        this.$nextTick(() => this.focarAcoes());
        return;
      }
      const pararDeObservar = this.$watch('loadingMarketing', (carregando) => {
        if (carregando) {
          return;
        }
        pararDeObservar();
        this.$nextTick(() => this.focarAcoes());
      });
    },
    // Rola até a primeira seção de ações (promoções ou cupons) — o card de
    // boas-vindas fica de fora.
    focarAcoes() {
      const alvo = this.$el.querySelector('.secaoHeader') || this.$el.querySelector('.secaoCta:not(.boasVindas)');
      if (alvo && alvo.scrollIntoView) {
        alvo.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    async carregarMarketing() {
      const vm = this;
      const ticket = ++vm.fetchToken;
      vm.loadingMarketing = true;
      vm.pedidosSmart = [];
      vm.estabelecimentoBloqueio = null;
      vm.cupons = [];
      vm.sectionsRemotas = [];
      vm.promos = [];
      vm.ultimasAlteracoesPromo = {};
      vm.bairrosEstabelecimento = [];

      const loja = vm.$root.estabelecimentoSelecionado;
      if (!loja || !loja.id) {
        if (ticket === vm.fetchToken) {
          vm.loadingMarketing = false;
        }
        return;
      }

      const hoje = vm.$dayjs();
      const dataInicio = hoje.subtract(28, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
      const dataFim = hoje.subtract(1, 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss');
      const isCardapioDigital = !!loja.cardapio_digital;
      vm.loadingBairros = true;

      // Falha em qualquer bloco não pode derrubar a tela: cada request tem
      // fallback próprio (lista vazia) e o bloqueio usa os dados da loja em memória.
      const safe = (promise, fallback) => promise.catch(() => fallback);

      const [pedidosRes, estabRes, cuponsRes, templatesRes, promosRes, bairrosRes, alteracoesPromo] = await Promise.all([
        safe(vm.$axios.get('/pedido', {
          params: {
            estabelecimento_id: loja.id,
            data_inicio: dataInicio,
            data_fim: dataFim,
            statusList: '0,1,2,3',
            orderDesc: 'data',
          },
        }), null),
        safe(vm.$axios.get('/estabelecimento', {
          params: {
            id: loja.id,
            delivery: true,
            ativo: 1,
            fields: 'delivery,vendas',
          },
        }), null),
        safe(vm.$axios.get('/cupom-desconto', {
          params: { estabelecimento_id: loja.id },
        }), null),
        safe(vm.$axios.get('/cupom-desconto/templates', {
          params: {
            estabelecimento_id: loja.id,
            cardapio_digital: isCardapioDigital ? 1 : 0,
          },
        }), null),
        isCardapioDigital
          ? Promise.resolve(null)
          : safe(vm.$axios.get('/campanha/promocao', {
            params: { estabelecimento_id: loja.id },
          }), null),
        safe(vm.$axios.get('/bairro-estabelecimento', {
          params: {
            estabelecimento_id: loja.id,
            localidade_id: loja.localidade_id,
          },
        }), null),
        isCardapioDigital
          ? Promise.resolve({})
          : safe(buscarUltimasAlteracoes(vm.$axios, {
            entidade: ENTIDADE_ITEM,
            estabelecimentoId: loja.id,
          }), {}),
      ]);

      if (ticket !== vm.fetchToken) {
        return;
      }

      vm.pedidosSmart = (pedidosRes && pedidosRes.data) || [];
      const fresh = ((estabRes && estabRes.data) || []).find(e => e.id === loja.id);
      vm.estabelecimentoBloqueio = fresh || loja;

      const cupons = (cuponsRes && cuponsRes.data) || [];
      _.forEach(cupons, cupom => {
        cupom.disponiveis = cupom.quantidade - cupom.utilizados;
        cupom.vigencia = cupom.data_inicio && cupom.data_fim ? 1 : 0;
      });
      vm.cupons = cupons;

      vm.sectionsRemotas = (templatesRes && templatesRes.data && templatesRes.data.sections) || [];
      vm.promos = ((promosRes && promosRes.data) || []).map(p => ({ ...p, loadingToggle: false, imagemQuebrada: false }));
      vm.ultimasAlteracoesPromo = alteracoesPromo;
      vm.bairrosEstabelecimento = (bairrosRes && bairrosRes.data) || [];
      vm.loadingBairros = false;
      vm.loadingMarketing = false;
    },
    // Após ativar um cupom pelo dialog, atualiza cupons e templates —
    // as contagens e o nível recalculam pelos computeds.
    async onCupomSalvo() {
      const vm = this;
      const loja = vm.estabelecimentoSelecionado;
      if (!loja || !loja.id) return;
      const ticket = vm.fetchToken;
      const safe = (promise, fallback) => promise.catch(() => fallback);
      const [cuponsRes, templatesRes] = await Promise.all([
        safe(vm.$axios.get('/cupom-desconto', {
          params: { estabelecimento_id: loja.id },
        }), null),
        safe(vm.$axios.get('/cupom-desconto/templates', {
          params: {
            estabelecimento_id: loja.id,
            cardapio_digital: vm.cardapioDigital ? 1 : 0,
          },
        }), null),
      ]);
      if (ticket !== vm.fetchToken) {
        return;
      }
      const cupons = (cuponsRes && cuponsRes.data) || [];
      _.forEach(cupons, cupom => {
        cupom.disponiveis = cupom.quantidade - cupom.utilizados;
        cupom.vigencia = cupom.data_inicio && cupom.data_fim ? 1 : 0;
      });
      vm.cupons = cupons;
      vm.sectionsRemotas = (templatesRes && templatesRes.data && templatesRes.data.sections) || [];
    },
    abrirArteCupom(cupom, recemAtivado = true, origem = 'template') {
      if (!cupom) {
        return;
      }
      this.$refs.dialogArte.abrirCupom({
        cupom: cupom,
        estabelecimento: this.estabelecimentoSelecionado || {},
        recemAtivado: !!recemAtivado,
        origem: origem,
      });
    },
    abrirArtePromocao(promo, recemAtivado, origem) {
      if (!promo) {
        return;
      }
      this.$refs.dialogArte.abrirPromocao({
        promo: promo,
        estabelecimento: this.estabelecimentoSelecionado || {},
        recemAtivado: !!recemAtivado,
        origem: origem || (recemAtivado ? 'ativacao' : 'lista'),
      });
    },
    abrirArteBoasVindas() {
      if (this.bloqueado) {
        this.dialogBloqueio = true;
        return;
      }
      this.$refs.dialogArte.abrirBoasVindas({
        estabelecimento: this.estabelecimentoSelecionado || {},
        origem: 'marketing',
        aviso: this.$root.isOnboardingAguardando ? ArteDivulgacao.AVISO_LOJA_NAO_ATIVADA : null,
      });
    },
    abrirAtivacaoCupom(cupom) {
      if (this.bloqueado) {
        this.dialogBloqueio = true;
        return;
      }
      this.$refs.dialogTemplate.open(cupom);
    },
    abrirAtivacaoPromo(promo) {
      if (this.bloqueado) {
        this.dialogBloqueio = true;
        return;
      }
      this.dialogPromo.promo = promo;
      this.dialogPromo.loading = false;
      this.dialogPromo.open = true;
    },
    abrirHistoricoPromo(promo) {
      this.$refs.dialogHistorico.abrir({
        entidade: ENTIDADE_ITEM,
        entidade_id: promo.id,
        titulo: promo.nome,
        subtitulo: promo.campanha_nome,
        estabelecimento_id: this.estabelecimentoSelecionado.id,
      });
    },
    fecharDialogPromo() {
      this.dialogPromo.open = false;
      this.dialogPromo.promo = null;
      this.dialogPromo.loading = false;
    },
    async confirmarAtivacaoPromo() {
      const vm = this;
      const promo = vm.dialogPromo.promo;
      if (!promo) return;
      vm.dialogPromo.loading = true;
      try {
        await vm.$axios.put('/campanha/promocao/item/status', {
          item_catalogo_id: promo.id,
          estabelecimento_id: vm.estabelecimentoSelecionado.id,
          status: 2,
          ativo: 1,
        });
        vm.$set(promo, 'status', 2);
        vm.$set(promo, 'ativo', 1);
        // O backend reativa a categoria promocional junto com o item — sem isso
        // a promo seguiria contando como não ativa em isAtivoPromo.
        vm.$set(promo, 'categoria_ativo', 1);
        vm.$firebase.logEvent('promotion_activated');
        window.getApp.$emit('APP_ALERT', { color: 'primary', text: 'Promoção ativada!' });
        vm.$root.getPromocoes(vm.estabelecimentoSelecionado.id);
        vm.fecharDialogPromo();
        // Promoção segmentada não tem arte — nem sugere.
        if (!ArteDivulgacao.promocaoSegmentada(promo)) {
          vm.abrirArtePromocao(promo, true, 'ativacao');
        }
      } catch (error) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Erro ao alterar a promoção' });
        vm.dialogPromo.loading = false;
      }
    },
    gerenciarCupons() {
      this.$firebase.logEvent('marketing_cupons_clicked');
      this.$router.push({ name: 'cupomDesconto' });
    },
    verPromocoes() {
      this.$firebase.logEvent('marketing_promocoes_clicked');
      this.$router.push({ name: 'CampanhaPromocao' });
    },
    abrirSelecaoLoja() {
      window.getApp.$emit('SELECT_ESTABELECIMENTO');
    },
    abrirSuporte(origem) {
      this.$firebase.logEvent('marketing_suporte_suspensao_clicked');
      registrarContatoSuporte(origem, this.estabelecimentoSelecionado);
      const loja = this.estabelecimentoSelecionado;
      const nome = loja ? (loja.nome + ' | ' + loja.id) : '';
      const raw = String((this.$root.FIREBASE_REMOTE_CONFIG && this.$root.FIREBASE_REMOTE_CONFIG.WPP_SUPORTE) || '5532988929726').replace(/\D/g, '');
      const phone = raw.startsWith('55') ? raw : ('55' + raw);
      const texto = encodeURIComponent('Olá, gostaria de saber sobre a suspensão da loja ' + nome);
      window.open('https://api.whatsapp.com/send?phone=' + phone + '&text=' + texto, '_blank');
    },
  },
}
</script>

<style lang="scss" scoped>
// ─── Aviso "selecione uma loja" ──────────────────────────────────────────────
.selecaoLojaAviso {
  display: flex;
  align-items: center;
  gap: 16px;
  background: linear-gradient(90deg, #FFF4E5 0%, #FFE9CC 100%);
  border: 1px solid #FFD9A8;
  border-radius: 12px;
  padding: 14px 18px;
  margin: 16px 0 8px;
  &__icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 2px 6px rgba(178, 106, 0, 0.12);
  }
  &__content { flex: 1; min-width: 0; }
  &__title {
    font-size: 14px;
    font-weight: 700;
    color: #7a4500;
    line-height: 1.3;
  }
  &__desc {
    font-size: 12.5px;
    color: #8a5a1f;
    margin-top: 2px;
    line-height: 1.45;
  }
  &__cta {
    background: #FF8C00 !important;
    border-radius: 10px !important;
    text-transform: none !important;
    font-weight: 600 !important;
    letter-spacing: 0 !important;
    height: 38px !important;
    flex-shrink: 0;
  }
  @media (max-width: 768px) {
    flex-wrap: wrap;
    &__cta { width: 100%; margin: 0 !important; }
  }
}

// ─── Banner de bloqueio ──────────────────────────────────────────────────────
.bloqueioBanner {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: #FDECEC;
  border: 1px solid #F5C6C8;
  border-radius: 16px;
  padding: 18px 22px;

  &__icon {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    background: #F9D7D8;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 21px;
  }
  &__content { flex: 1; min-width: 0; }
  &__kicker {
    color: #B3261E;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.1em;
  }
  &__titulo {
    color: #7A1712;
    font-weight: 700;
    font-size: 17px;
    margin-top: 2px;
  }
  &__mensagem {
    font-size: 12px;
    color: #8C3B37;
    line-height: 1.5;
    margin-top: 4px;
    max-width: 720px;
  }
  &__como {
    background: #fff;
    border-radius: 12px;
    padding: 10px 12px;
    margin-top: 12px;
    font-size: 11.5px;
    color: #7A1712;
    line-height: 1.5;
  }
  &__cta {
    background: #B3261E !important;
    border-radius: 10px !important;
    text-transform: none !important;
    font-weight: 600 !important;
    letter-spacing: 0 !important;
    margin-left: 0 !important;
  }
}

.bloqueioNota {
  margin-top: 20px;
  background: #FDF3F3;
  border: 1px dashed #F5C6C8;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 12px;
  color: #8C3B37;
}

// ─── Headers de seção ────────────────────────────────────────────────────────
.secaoHeader {
  display: flex;
  align-items: center;
  gap: 8px;

  &__titulo {
    font-size: 15px;
    font-weight: 700;
    color: #1E2330;
    &--bloqueado { color: #9CA3AF; }
  }
  &__badge {
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 999px;
    &--verde   { background: #DCEFE4; color: #1E7A46; }
    &--laranja { background: #FCEBD2; color: #B96A00; }
  }
  &__lock {
    font-size: 13px;
    color: #B3261E;
  }
  &__link {
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    text-decoration: none;
    &--verde   { color: #1E9E57; }
    &--laranja { color: #F08C00; }
    &:hover { text-decoration: underline; }
  }
}

// ─── Carrossel de prévias (linha única com scroll horizontal) ────────────────
.mktCarrossel {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 14px;
  overflow-x: auto;
  overflow-y: hidden;
  // Oculta o indicador de scroll (mantém o scroll funcional)
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar { display: none; }

  // Wrapper de cada card: é o flex item que estica à altura do mais alto
  // (align-items: stretch); o card interno preenche 100% da largura/altura,
  // garantindo cards de mesma altura independentemente do conteúdo.
  &__item {
    flex: 0 0 auto;
    display: flex;
    &--cupom { width: 280px; }
    &--promo { width: 400px; }
    & > * { width: 100%; }
  }
}

// ─── Card-CTA (seção sem prévias) ────────────────────────────────────────────
.secaoCta {
  display: flex;
  align-items: center;
  gap: 16px;
  background: #fff;
  border: 1px solid #ECECEE;
  border-radius: 16px;
  padding: 18px 20px;
  margin-top: 10px;

  &__icon {
    width: 48px;
    height: 48px;
    flex-shrink: 0;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 21px;
  }
  &--verde .secaoCta__icon   { background: #EAF6EF; }
  &--laranja .secaoCta__icon { background: #FFF4E0; }

  &__textos { flex: 1; min-width: 0; }
  &__titulo {
    font-size: 16px;
    font-weight: 700;
    color: #1E2330;
  }
  &__sub {
    font-size: 12.5px;
    color: #6B7280;
    margin-top: 2px;
    line-height: 1.45;
  }
  &__btn {
    border-radius: 10px !important;
    text-transform: none !important;
    font-weight: 600 !important;
    font-size: 12.5px !important;
    letter-spacing: 0 !important;
    height: 40px !important;
    flex-shrink: 0;
    margin: 0 !important;
    &--verde   { background: #1E9E57 !important; }
    &--laranja { background: #F08C00 !important; }
  }

  @media (max-width: 600px) {
    flex-wrap: wrap;
    &__btn { width: 100%; }
  }
}

// Card da arte de boas-vindas: a miniatura da fachada no lugar do ícone.
.boasVindas__thumb {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 12px;
  object-fit: cover;
}

// ─── Tip ─────────────────────────────────────────────────────────────────────
.marketingTip {
  background: #F6FAFF;
  border: 1px dashed #C8DAF7;
  border-radius: 12px;
  padding: 14px 18px;
  margin-top: 24px;
  &__head {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  &__icon {
    flex-shrink: 0;
  }
  &__title {
    font-size: 13.5px;
    font-weight: 700;
    color: #1a3866;
  }
  &__desc {
    font-size: 12.5px;
    color: #4a6080;
    margin-top: 2px;
    line-height: 1.45;
    padding-left: 36px;
  }
}

// ─── Skeleton loader ─────────────────────────────────────────────────────────
@keyframes previewShimmer {
  0%   { background-position: -400px 0; }
  100% { background-position: 400px 0; }
}
.skeleton-line {
  display: block;
  width: 100%;
  height: 14px;
  border-radius: 6px;
  background: #ececec;
  background-image: linear-gradient(90deg, #ececec 0px, #f5f5f5 80px, #ececec 160px);
  background-size: 400px 100%;
  background-repeat: no-repeat;
  animation: previewShimmer 1.2s infinite linear;
}
.skeleton-line--md { height: 16px; width: 35%; }
.skeleton-line--xl { height: 34px; width: 50%; }
.skeleton-line--short { width: 60%; }
.previewSkeleton {
  background: #fff;
  border: 1px solid #ECECEE;
  border-radius: 14px;
  padding: 16px;
  pointer-events: none;
  &__cta { height: 36px; border-radius: 9px; }
}
</style>
